<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              <el-select
                v-model="tradeSwitch"
                placeholder="交易对开关"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in tradeSwitchArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="主键ID" clearable v-model="id" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对ID"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          <!-- <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div> -->

          <div class="item">
            <el-button v-if="$hasPerm('tenant:copy_trader_tag:add')" size="mini" type="primary"
              @click="show">新增</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="标签编号" prop="id" width="100" />
        <el-table-column label="标签code" prop="label" />
        <el-table-column label="中文名称" prop="zhName" />

        <!-- <el-table-column prop="" label="交易开关">
          <template slot-scope="scope">
            <span>{{ scope.row.tradeSwitch ? "开" : "关" }}</span>
          </template>
</el-table-column> -->
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="$hasPerm('tenant:copy_trader_tag:delete')" type="text" size="mini"
              @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="paginationHandle"
        >
        </pagination> -->

      <el-dialog :title="title" :visible="dialogVisible" width="400px" @close="close" :destroy-on-close="true">
        <el-form ref="formData" :model="formData" size="medium" label-width="100px">
          <el-form-item label="标签code" prop="">
            <el-input :min="0" v-model="formData.label"></el-input>
          </el-form-item>
          <el-form-item label="标签中文" prop="">
            <el-input :min="0" v-model="formData.zhValue"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button v-if="$hasPerm('tenant:copy_trader_tag:add')" type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: { label: "", zhValue: "" },
    };
  },
  computed: {},
  mounted() {
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api.copytradeLabel().then((res) => {
        if (res.code == 0) {
          this.tabList = res.data;
          // this.totalCount = totalCount;
        }
      });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        label: "",
        zhValue: "",
      };
    },
    handleSave() {
      if (this.formData.label == "") {
        return this.$message.error("请输入标签code");
      }
      if (this.formData.lazhValuebel == "") {
        return this.$message.error("请输入标签中文");
      }
      api.addLabel(this.formData).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
    del(row) {
      api.deleteLabel({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功");
          this.handleSearch();
        }
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
